import { useEffect, useState } from "react";
import { IRBDItem } from "../../../models/rbd";
import { IDiagramValues } from "./Diagram";
import { 
    isSerialTransmission, 
    isElement, 
    isParalelTransmission, 
    isRedundantTransmission 
} from './helper/validator';
import { handleElement } from "./handler/element.handler";
import { handleSerial } from "./handler/serial.handler";
import { handleParalel } from './handler/paralel.handler';
import { handleRedundant } from "./handler/redundant.handler";
import { useStore } from "../../../stores/store";

function handleValue(rbdItem: IRBDItem[]): IDiagramValues[] {
    let prev: IRBDItem | undefined;
    let visibles: IRBDItem[] = [];
    let result: IDiagramValues[] = [];
    
    rbdItem.map(i => !i.isGrouped && visibles.push(i))

    visibles.map((visible, index) => {
        prev = visibles[index - 1]

        if (isElement(visible)) {
            const element = handleElement(visible, prev)
            return result.push(element)
        } else {
            if (isSerialTransmission(visible)) {
                const serial = handleSerial(visible, prev)
                return result.push(...serial)
            } else if (isParalelTransmission(visible)) {
                const paralel = handleParalel(visible, prev)
                return result.push(...paralel)
            } else if (isRedundantTransmission(visible)) {
                const redundant = handleRedundant(visible, prev)
                return result.push(...redundant)
            } else {
                return result
            }
        }
    })

    return result
}

export const useDiagram = (rbdItem: IRBDItem[]) => {
    const [value, setValue] = useState<IDiagramValues[]>([])
    const { injectDiagramValue, clearDiagram } = useStore().rbdStore
    
    useEffect(() => {
        setValue(handleValue(rbdItem))
    }, [rbdItem])

    useEffect(() => {
        injectDiagramValue(value)
        return () => clearDiagram()
    }, [value, clearDiagram, injectDiagramValue])

    return value
}